const formatLocation = (city?: string | null, state?: string | null) =>
  [city, state].filter(Boolean).join(', ');

export const buildAccountOptions = (
  accountsData: ManagedPlatformAccountsQuery | undefined,
) => {
  const accounts = accountsData?.managedPlatformAccounts?.collection || [];
  return accounts.map((account) => ({
    id: account.id,
    label: account.name,
    value: account.id,
    labelDetails: formatLocation(account.city, account.state) || undefined,
  }));
};
